import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 lg:px-20 bg-background-50 relative overflow-hidden">
      <div className="max-w-[1280px] mx-auto text-center relative z-10">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mb-4">
          Inizia oggi con Itaobuy Sheet
        </h2>
        <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto mb-8">
          Accedi al database completo di prodotti selezionati, foto QC e guide dettagliate per i tuoi acquisti.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-2 px-7 py-3.5 rounded-full bg-foreground-900 text-background-50 font-semibold text-sm hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap"
          >
            <span>Accedi al database completo</span>
            <i className="ri-arrow-right-up-line text-base"></i>
          </a>
          <a
            href="/guida-itaobuy-spreadsheet"
            className="flex items-center gap-2 px-7 py-3.5 rounded-full border border-background-300 text-foreground-700 font-medium text-sm hover:border-primary-400 hover:text-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            <span>Leggi la guida completa</span>
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-background-100/50"></div>
    </section>
  );
}